import { FeatureAppNames } from './app-constants';
import { createMofaConfig } from './create-mofa-config';
import { ModelOverviewIntegratorOptions } from './create-options-from-query-params';
import { defaultAppConfig } from './default-app-config';
import { FIVE_STARS_FEATURE_APP_CONTENT } from './feature-app-content/create-five-stars-content';
import { createFiveStarsAppConfig } from './feature-app-configs/create-five-stars-app-config';

const getCreateFunctionInstance = (featureAppName: string | undefined) => {
  switch (featureAppName) {
    case FeatureAppNames.FIVE_STARS as string:
      return createFiveStarsAppConfig;
    case FeatureAppNames.DEFAULT as string:
      return defaultAppConfig.createFunctionInstance;
    default:
      return createMofaConfig;
  }
};

export const getConfigsFeatureApp = ({
  featureAppName,
  ...props
}: ModelOverviewIntegratorOptions) => {
  const createFunctionInstance = getCreateFunctionInstance(featureAppName);
  return createFunctionInstance(props);
};

export const contentFeatureAppMap = {
  [FeatureAppNames.FIVE_STARS]: FIVE_STARS_FEATURE_APP_CONTENT,
  [FeatureAppNames.DEFAULT]: defaultAppConfig.appContent,
};
